/** @prettier */
// @flow
import React from 'react';

import { sendClick, XAEvents } from '../../../../utils/init-xsolla-analytics';

type Props = {
  value: string,
  onClick: Function,
  merchantId: string,
  isServerSideRender: boolean,
};

const GooglePlay = ({
  value,
  onClick,
  merchantId,
  isServerSideRender,
}: Props) => {
  const handleClick = () => {
    onClick();
    sendClick(merchantId, XAEvents.clickOnGooglePlayButton);
  };

  if (isServerSideRender && value) {
    return (
      <a
        className='ui-site-calltoaction ui-site-calltoaction--gplay'
        onClick={handleClick}
        href={value}
        rel='noopener noreferrer'
        target='_blank'
        data-button-type={XAEvents.clickOnGooglePlayButton}
      />
    );
  }
  return (
    <button
      className='ui-site-calltoaction ui-site-calltoaction--gplay'
      onClick={handleClick}
    />
  );
};

export default GooglePlay;
